import { useTranslate } from "@tolgee/react";
import React from "react";
import { type ItemBinding } from "../../../../clients/graphqlTypes.js";

export type ItemChange = "change";

const BINDINGS: ItemBinding[] = ["binding", "non_binding", "draft"];

export function useItemBindings() {
  const { t } = useTranslate("QuoteEdit");

  const itemBindingLabels: Record<ItemBinding, string> = React.useMemo(
    () => ({
      binding: t("Binding"),
      non_binding: t("Non-Binding"),
      draft: t("Draft"),
    }),
    [t]
  );

  const itemBindingOptions = React.useMemo(
    () =>
      BINDINGS.map(itemBinding => ({
        value: itemBinding,
        label: itemBindingLabels[itemBinding],
      })),
    [itemBindingLabels]
  );

  const itemBindingWithChangeOptions = React.useMemo(
    () => [
      ...BINDINGS.map(itemBinding => ({
        value: itemBinding,
        label: itemBindingLabels[itemBinding],
      })),
      { value: "change" as ItemChange, label: t("Change") },
    ],
    [itemBindingLabels, t]
  );

  return {
    itemBindingLabels,
    itemBindingOptions,
    itemBindingWithChangeOptions,
  };
}
